import * as React from 'react'

import { CardCount } from './interface'
import { CardContent } from './style'

const TimelineCardContent: React.FC<CardCount> = ({ cardCount, children }) => (
  <CardContent cardCount={cardCount}>{children}</CardContent>
)

export default TimelineCardContent
